import css from "standard/css";

const style = css`
  .avatar {
    border-radius: var(--border-radius-circular);
    height: 128px !important;
    margin: 0 auto;
    width: 128px !important;
    object-fit: cover;
    object-position: top center;
  }

  .avatar__container {
    align-items: center;
    display: flex;
    gap: var(--spacing_inset-sm);
  }

  .avatar__label {
    align-items: center;
    background-color: var(--color-pure-white);
    border: var(--border-width-thin) solid var(--color-ocean);
    border-bottom: 2px solid #5c9ac1;
    border-radius: var(--border-radius-sm);
    box-shadow: 0 15px 0 var(--color-ocean);
    text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
    color: var(--color-ocean);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    padding: var(--spacing-nano) var(--spacing-xxxs);
    justify-content: center;
  }

  .avatar__label:active {
    box-shadow: none;
    transform: translateY(5px);
  }

  .avatar__input {
    display: none;
  }
`;

export default style;
